import React from 'react';
import PropTypes from 'prop-types';
import utils from 'helpers/utils';
import { connect } from 'react-redux';
import { fetchMembershipSchedule } from 'store/actions/membership-schedules/fetchMembershipSchedules';

class MembershipScheduleField extends React.Component {
    componentDidMount() {
        const { scheduleId, schedule, fetch } = this.props;

        if (utils.isEmpty(schedule)) {
            fetch(scheduleId);
        }
    }

    render() {
        const { schedule } = this.props;

        if (utils.isEmpty(schedule)) {
            return null;
        }

        return (
            <span>{ schedule.name }</span>
        );
    }
}

MembershipScheduleField.propTypes = {
    fetch: PropTypes.func.isRequired,
    scheduleId: PropTypes.number.isRequired,
    schedule: PropTypes.object,
};

const mapStateToProps = (state, props) => {
    const { record, source } = props;

    let identifier = null;

    if (record[source]) {
        identifier = record[source];
    }

    return {
        schedule: state['membership-schedules'].data[identifier],
        scheduleId: identifier,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetch: (scheduleId) => {
            dispatch(fetchMembershipSchedule({
                id: scheduleId,
            }));
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(MembershipScheduleField);



// WEBPACK FOOTER //
// ./src/components/field/MembershipScheduleField.js